export default __webpack_public_path__ + "static/media/Add Language_Blue.9aa5b07a.svg";